import api from "./client";

import type { ApiResponse } from "#/types/api";
import type { InventoryScanReport } from "#/types/report";

export const reportApi = {
  getInventoryScanReport: (): Promise<ApiResponse<InventoryScanReport>> =>
    api.get("/report/inventory-scan"),
};
